class InputAsSelect extends HTMLElement
{
  constructor ()
  {
    super();

    this.input = this.querySelector('input');
    this.select = this.querySelector('custom-select');
    this.init();
  }

  init ()
  {
    this.input.addEventListener('click', e => {
      e.stopPropagation();
      this.updateAndShow();
    });

    this.input.addEventListener('focusin', (e) => {
      this.updateAndShow();
    });

    ['change', 'keyup', 'input', 'blur'].forEach(event => this.input.addEventListener(event, e => {
      setTimeout(()=> {
        this.updateAndShow();
      }, 10);
    }));

    this.select.querySelector('select').addEventListener('change', e => {
      this.input.value = this.querySelector('.custom-select-value').innerText;
    });
  }

  updateAndShow ()
  {
    const searchInput = this.select.closest('.custom-select').querySelector('.custom-select-search input');
    searchInput.value = this.input.value;
    this.select.closest('.custom-select').classList.add('open');
    this.select.search();
  }
}

if (!customElements.get('input-as-select')) {
  customElements.define('input-as-select', InputAsSelect);
}